export default "__VITE_ASSET__BERDOiRP__";